import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackDBlue = ({ state, workState, onLabelClick }) => (
	<g id="TrackDBlue" transform="translate(1430.000000, 870.000000)" className="track">
		<path
			d="M10.1824124,53 L5.1367692,48.4804266 C1.68155918,45.1747232 0.117604557,41.2065275 0.444905316,36.5758394 C0.594186246,34.463796 1.15202006,32.5831575 2.11840676,30.9339238 M9.76361628,24.5531913 L44,4"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow
			transform="translate(11.578348, 23.305061) rotate(-392.000000) translate(-11.578348, -23.305061) "
			points="15.5783483 31.305061 7.57834831 23.305061 15.5783483 15.305061"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackDBlue')}
			coords="17.000000, 0.000000"
			text="D"
			textCoordsX="8.42214627"
			textCoordsY="17.1388889"
			size="small"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

TrackDBlue.propTypes = trackPropTypes;

export default TrackDBlue;
